<template>
    <section>
        <modal-alert-global />
        <modal-listar-evidencia :consultaEvidencias="this.$store.state.evidenciasPorMes.evidencias" />
        <modal-inserir-evidencia />
        <modal-historico-sla />
        <modal-form-exibir-notificacao />
        <modal-historico-notificacao :consultaHistoricoNotificacoes="this.$store.state.historicoNotificacoes.historicoNotificacoes" />
        <modal-alert-calendario />
        <modal-permissao-negada />
        <modal-adiconar-glosa />
        <modal-listar-glosas :glosasMesAtual="this.$store.state.modal.modalListaGlosasPorMes" />
        <modal-extraContratual v-if="this.$store.state.modal.extraContratual.show" />
        <modal-confirmar-multa-glosa :multas="this.$store.state.confirmarMultaGlosa.dados" />
        <modal-alert-atualizacoes />
    </section>
</template>

<script>
import alertGlobal from './AlertGlobal.vue'
import modalListarEvidencia from '../evidencia/modal/ModalListarEvidencia.vue'
import inserirEvidencia from './InserirEvidencia.vue'
import modalHistoricoSla from '../sla/modal/ModalHistoricoSla.vue'
import modalFormExibirNotificacao from '../notificacao/modal/ModalFormExibirNotificacao.vue'
import modalHistoricoNotificacao from '../notificacao/modal/ModalHistoricoNotificacao.vue'
import alertCalendario from './AlertCalendario.vue'
import permissaoNegada from './permissoes/PermissaoNegada.vue'
import adicionarGlosa from '../glosa/modal/ModalAdicionarEvidenciaGlosa.vue'
import listarGlosas from '../glosa/modal/ModalListarGlosas.vue'
import extraContratual from './extraContratual/AplicarExtraContratual.vue'
import modalConfirmarMultaGlosa from '../sla/modal/ModalConfirmarMultaGlosa'
import alertAtualizacoes from './AlertAtualizacoes.vue'

export default {
  components: {
    'modal-alert-global': alertGlobal,
    'modal-listar-evidencia': modalListarEvidencia,
    'modal-inserir-evidencia': inserirEvidencia,
    'modal-historico-sla': modalHistoricoSla,
    'modal-form-exibir-notificacao': modalFormExibirNotificacao,
    'modal-historico-notificacao': modalHistoricoNotificacao,
    'modal-alert-calendario': alertCalendario,
    'modal-permissao-negada': permissaoNegada,
    'modal-adiconar-glosa': adicionarGlosa,
    'modal-extraContratual': extraContratual,
    'modal-listar-glosas': listarGlosas,
    'modal-confirmar-multa-glosa': modalConfirmarMultaGlosa,
    'modal-alert-atualizacoes': alertAtualizacoes
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?3d0a6422